var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcStarNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72931 28.7023C5.57331 29.5903 6.44931 30.2843 7.22131 29.8883L16.0013 25.3763L24.7793 29.8883C25.5513 30.2843 26.4273 29.5903 26.2713 28.7043L24.6113 19.2443L31.6553 12.5323C32.3153 11.9043 31.9753 10.7563 31.0913 10.6323L21.2953 9.24029L16.9273 0.586287C16.8441 0.410865 16.7128 0.262654 16.5487 0.158872C16.3846 0.0550909 16.1945 0 16.0003 0C15.8062 0 15.616 0.0550909 15.4519 0.158872C15.2878 0.262654 15.1565 0.410865 15.0733 0.586287L10.7053 9.24229L0.909307 10.6343C0.0273069 10.7583 -0.314693 11.9063 0.343307 12.5343L7.38931 19.2463L5.72931 28.7063V28.7023ZM15.5393 23.1683L8.16731 26.9563L9.55531 19.0423C9.58782 18.8601 9.5751 18.6727 9.51826 18.4966C9.46142 18.3205 9.36219 18.1611 9.22931 18.0323L3.41731 12.4923L11.5213 11.3403C11.6891 11.3149 11.8483 11.2493 11.9852 11.149C12.1221 11.0487 12.2326 10.9167 12.3073 10.7643L15.9973 3.44829L19.6913 10.7643C19.766 10.9167 19.8766 11.0487 20.0134 11.149C20.1503 11.2493 20.3095 11.3149 20.4773 11.3403L28.5813 12.4903L22.7693 18.0303C22.6361 18.1593 22.5367 18.3191 22.4798 18.4955C22.423 18.672 22.4104 18.8598 22.4433 19.0423L23.8313 26.9563L16.4593 23.1683C16.3168 23.0948 16.1587 23.0564 15.9983 23.0564C15.8379 23.0564 15.6799 23.0948 15.5373 23.1683H15.5393Z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStarNormal);
export default __webpack_public_path__ + "static/media/ic-star-normal.edfd2d7d41175780687f4f11a826a299.svg";
export { ForwardRef as ReactComponent };